import { useCallback } from 'react'

import { Select } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'
import { DateTemplateInput, DateTemplateType } from 'types/graphql'

const options: SelectOption<DateTemplateType>[] = [
  {
    label: 'Interval',
    value: 'Interval',
  },
  {
    label: 'Exact date',
    value: 'Date',
  },
]

type Props = {
  dateTemplate: Partial<DateTemplateInput>
  isClearable?: boolean
  isDisabled?: boolean
  onChange: (value: Partial<DateTemplateInput>) => void
  width?: React.CSSProperties['width']
}
const DateTemplateTypeSelect = ({
  dateTemplate,
  isClearable,
  isDisabled,
  onChange,
  width,
}: Props) => {
  const handleChange = useCallback(
    (newSelectedOption: SelectOption<DateTemplateType> | undefined) => {
      const newType = newSelectedOption?.value
      if (dateTemplate.type === newType) {
        return
      }
      onChange({
        ...dateTemplate,
        type: newType,
        ...(newType === 'Interval'
          ? {
              interval: {
                count: undefined,
                relativeToDate: 'Now',
                temporalPosition: 'After',
                type: undefined,
              },
            }
          : {}),
        ...(newType === 'Date'
          ? {
              date: {
                day: 31,
                month: 12,
              },
            }
          : {}),
      })
    },
    [dateTemplate, onChange]
  )
  return (
    <Select
      ariaLabel="Delay type"
      placeholder="Delay type"
      options={options}
      getOptionKey={(o) => o.value}
      isClearable={isClearable}
      isDisabled={isDisabled}
      onSelectedOptionChange={handleChange}
      selectedOption={options.find((o) => o.value === dateTemplate.type)}
      width={width}
    />
  )
}

export default React.memo(DateTemplateTypeSelect)
